module.exports = __webpack_public_path__ + "staticcomp/img/icon.bfda76e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon.jpg
// module id = cODK
// module chunks = 39